<template>
    <v-container class="grey lighten-5">
        <v-sheet dense v-for="(item,i) in rules" :key="i" color="extraLightGrey">
            <v-sheet class="d-flex flex-row flex-nowrap">
                <v-row dense>
                    <v-col cols="4">
                        <v-select outlined dense hide-details background-color="white"
                                  :label="Translate('Operator')"
                                  v-model="item.condition"
                                  :items="condition_types"
                                  item-text="text"
                                  item-value="value"
                                  :menu-props="{ offsetY: true }"
                                  @change="updateReport"></v-select>
                    </v-col>
                    <v-col cols="8">
                        <v-text-field outlined dense hide-details background-color="white"
                                      :label="Translate('Value')"
                                      v-model="item.value"
                                      :disabled="item.condition == 'empty' || item.condition == 'notempty' || item.condition == 'missing'"
                                      @input="updateReport"></v-text-field>
                    </v-col>
                </v-row>
                <v-btn icon class="mr-n9" v-if="i > 0" @click="removeCondition()">
                    <v-icon>mdi-window-close</v-icon>
                </v-btn>
            </v-sheet>

            <v-row v-if="i < 1" v-show="rules.length > 1" justify="center">

                <v-radio-group :value="item.combiner" @change="(value) => setItemCombiner(item, i, value)" mandatory row class="mt-6 mb-1 ml-1">
                    <v-radio :label="Translate('AND')" value="AND">
                    </v-radio>
                    <v-radio :label="Translate('OR')" value="OR">
                    </v-radio>
                </v-radio-group>

            </v-row>
        </v-sheet>
        <v-hover>
            <v-btn v-show="rules.length < 2" elevation="0" class="px-0 customHoverButton" @click="addCondition()">
                <v-icon left class="mr-1">
                    mdi-plus
                </v-icon>
                {{ Translate('Add Rule') }}
            </v-btn>
        </v-hover>
    </v-container>
</template>

<script>
    import _ from 'lodash';
    import methods from '@/Shared/methods';

    export default {
        data: function () {
            return {
                rules: [{ condition: 'contains', value: '', combiner: undefined }],
            }
        },
        props: {
            item: Object,
            value: null,
        },
        created() {
            const self = this;
            this.updateReportDebouncer = _.debounce(function () {
                //debugger;
                if (self.rules.length < 1 || self.rules.some(a => !a.value && a.condition != 'empty' && a.condition != 'notempty' && a.condition != 'missing')) {
                    // Either an empty list (shouldn't happen) or an empty value on the first rule means no filter
                    self.$emit('change', {});
                    return;
                }

                if (self.rules.length == 1)
                    // Single rule scenario is the simplest format (made popular by ag-grid)
                    self.$emit('change', {
                        filterType: "text",
                        type: self.rules[0].condition,
                        filter: self.rules[0].value,
                    });
                else
                    // Multiple rule scenario puts the conditions into an array
                    self.$emit('change', {
                        filterType: "text",
                        operator: self.rules[0].combiner,
                        conditions: self.rules.map(a => ({
                            type: a.condition,
                            filter: a.value,
                        }))
                    });

            }, 500);

            if (this.value && this.value.type) {
                this.rules = [{
                    condition: this.value.type,
                    value: this.value.filter,
                }];
            }
            else if (this.value && this.value.conditions && this.value.conditions.length == 2) {
                this.rules = [{
                    condition: this.value.conditions[0].type,
                    value: this.value.conditions[0].filter,
                    combiner: this.value.operator,
                }, {
                    condition: this.value.conditions[1].type,
                    value: this.value.conditions[1].filter,
                }];
            }
        },
        watch: {
            rules: function (newv) {
                this.updateReport();
            },
            value: {
                handler(newValue) {
                    this.syncFromProps(newValue);
                },
                deep: true,
                immediate: true 
            },
        },
        computed: {
            condition_types: function() {
                return [
                    { text: this.Translate('Equals'), value: 'equals' },
                    { text: this.Translate('Does Not Equal'), value: 'notEquals' },
                    { text: this.Translate('Contains'), value: 'contains' },
                    { text: this.Translate('Does Not Contain'), value: 'notcontains' },
                    { text: this.Translate('Begins With'), value: 'beginsith' },
                    { text: this.Translate('Ends With'), value: 'endswith' },
                    { text: this.Translate('Blank'), value: 'empty' },
                    { text: this.Translate('Not Blank'), value: 'notempty' },
                    { text: this.Translate('Missing'), value: 'missing' },
                ];
            },
        },
        methods: {
            ...methods,
             syncFromProps(value) {
                if (!value || Object.keys(value).length === 0 || value.cleared == 1 ||  (value.filterType === 'set' && (!value.values || value.values.length === 0)) ) {
                     if (this.rules.length > 0) {
                          this.rules = [];
                     }
                }
            },
            updateReport() {
                this.updateReportDebouncer();
            },
            setItemCombiner(item, index, value) {
                console.log(`setItemCombiner[${index}] to ${value}:`);
                console.log(JSON.stringify(item, null, 3));

                //if (index == this.rules.length - 1) {
                //    if (item.combiner === undefined && value !== undefined)
                //        // When changing the last item, setting to a non-undefined value will add a new row to the rules array
                //        this.rules.push({ condition: 'equal', value: '', combiner: undefined });
                //}
                //else if (index < this.rules.length - 1) {
                //    if (value === undefined)
                //        // When changing a non-last item to undefined, we will remove all following rules
                //        this.rules.splice(index + 1, this.rules.length - index - 1);
                //}

                item.combiner = value;
                this.updateReport();
            },
            addCondition() {
                this.rules.push({ condition: 'contains', value: '', combiner: undefined });
            },
            removeCondition() {
                this.rules.pop();
            }
        }
    }
</script>

<style scoped>
    .customHoverButton:before {
        background-color: unset !important;
        transition: unset !important;
    }

    .customHoverButton {
        background-color: unset !important;
        color: var(--v-primary-base);
    }

        .customHoverButton:hover {
            filter: brightness(80%);
        }
</style>